<template>
  <div class="about-view">
    <Breadcrumb />
    <div class="about-header">
      <span class="title-watermark">ABOUT US</span>
      <h1 class="page-title">公司介绍</h1>
      <div class="desc">海南鼎昂建筑工程有限公司——诚信筑业，创新鼎新，专注于为客户提供高品质建筑工程服务。</div>
    </div>
    <section class="about-section">
      <h1 style="display:none">公司简介</h1>
      <div class="about-content">
        <p>海南鼎昂建筑工程有限公司是一家植根海南、面向全国，致力于提供全方位建筑工程服务的现代化企业。公司自成立以来，始终秉承"诚信筑业，创新鼎新"的理念，积极参与海南自由贸易港建设及全国各地的城市建设浪潮。</p>
        <h3>实力筑基，资质完备</h3>
        <p>
          鼎昂建工拥有建筑工程施工总承包壹级、市政公用工程施工总承包壹级等核心资质，并具备建筑装修装饰工程专业承包壹级、钢结构工程专业承包贰级、建筑机电安装工程专业承包贰级、环保工程专业承包叁级等多项专业资质。公司业务涵盖房屋建筑工程、市政道路桥梁工程、公共设施建设、大型场馆、商业综合体、高端住宅、工业厂房、建筑装饰装修、钢结构工程、机电设备安装、环保工程及园林绿化工程等领域，具备承接大型、复杂、综合性工程项目的雄厚实力。
        </p>
        <h3>深耕海南，服务全国</h3>
        <p>
          鼎昂建工以海南为发展根基，深刻理解本地市场与建设需求，将企业发展融入区域经济腾飞的大潮。公司坚持以质量求生存，以信誉谋发展，凭借科学的管理、精湛的技术和高效的执行力，业务范围已从海南本岛稳步拓展至全国多个省市。近年来，公司年施工产值持续稳步增长，已成为海南建筑行业颇具影响力的骨干力量。
        </p>
        <h3>匠心筑品，管理护航</h3>
        <p>
          公司恪守"匠心筑精品，诚信赢未来"的企业宗旨，建立了完善且高效的质量管理体系、环境管理体系和职业健康安全管理体系（QHSE）。目前，公司设有多个专业职能部门及区域分公司，汇聚了一支高素质的专业人才队伍。现有各类有职称的工程技术和经济管理人员300余人，其中一级注册建造师、项目负责人50余人，中高级专业工程师180余人，并拥有多名省级建筑行业专家库成员，为项目的精益管理和卓越品质提供坚实保障。
        </p>
        <h3>荣誉载道，砥砺前行</h3>
        <p>
          鼎昂建工奉行"务实、协作、进取、担当"的企业精神，坚持"客户至上，品质为先"的服务理念。公司承建的多个项目荣获省级"绿岛杯"优质工程奖、省级安全文明施工标准化工地（"省双优"工地）等荣誉，并多次获得业主单位颁发的"优秀合作单位"称号。公司始终重视合同履约和商业信誉，连续多年被评为海南省"守合同重信用企业"，是税务系统认可的诚信纳税单位。
        </p>
        <h3>扬帆自贸港，奋进新时代</h3>
        <p>
          "椰风海韵千帆竞，鼎立潮头奋者先"。在海南自由贸易港建设日新月异的宏伟蓝图下，在全国建筑业转型升级的关键时期，海南鼎昂建筑工程有限公司将紧抓历史机遇，持续深化内部改革，积极拥抱BIM技术、绿色建筑、智能建造等前沿科技，不断提升核心竞争力。公司将始终牢记企业社会责任，将经济效益、员工福祉与社会贡献紧密结合，以更加开放的姿态、更加卓越的品质、更加昂扬的斗志，与各界伙伴精诚合作，共筑美好未来，为城市建设和经济社会发展贡献鼎昂力量！
        </p>
      </div>
    </section>
    <section class="culture-section">
      <h2>发展历程</h2>
      <ul class="timeline">
        <li><span class="year">2020</span> 海南鼎昂建筑工程有限公司成立，扎根三亚，开启建筑服务新征程。</li>
        <li><span class="year">2021</span> 首批市政与房建项目顺利交付，建立高效管理团队，完善企业资质体系。</li>
        <li><span class="year">2022</span> 业务拓展至海南全岛及华南地区，荣获多项省级优质工程奖项。</li>
        <li><span class="year">2023</span> 深度参与海南自贸港重点工程，推动BIM、绿色建造等新技术应用，企业影响力持续提升。</li>
        <li><span class="year">2024</span> 设立多地分公司，团队规模突破300人，迈向全国市场，开启高质量发展新篇章。</li>
      </ul>
    </section>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
export default {
  name: 'AboutView',
  components: { Breadcrumb }
};
</script>

<style scoped>
.about-view {
  padding: 32px;
  max-width: 900px;
  margin: 0 auto;
}

.about-section {
  margin-bottom: 48px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
  padding: 36px 28px 32px 28px;
}

.about-section h1 {
  text-align: center;
  font-size: 2.1rem;
  font-weight: 700;
  color: #1a2a47;
  margin-bottom: 28px;
  letter-spacing: 1px;
}

.about-content h3 {
  margin-top: 22px;
  margin-bottom: 8px;
  font-size: 1.18rem;
  color: #2563eb;
  font-weight: 600;
}

.about-content p {
  text-align: justify;
  color: #333;
  font-size: 1.05rem;
  line-height: 2.1;
  margin-bottom: 0;
}

.culture-section {
  margin-bottom: 40px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
  padding: 32px 28px 28px 28px;
}

.culture-section h2 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a2a47;
  margin-bottom: 24px;
  letter-spacing: 1px;
}

.timeline {
  padding-left: 0;
  list-style: none;
  margin: 0;
}

.timeline li {
  position: relative;
  padding-left: 32px;
  margin-bottom: 18px;
  font-size: 1.05rem;
  color: #444;
  line-height: 1.9;
}

.timeline li::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 8px;
  width: 8px;
  height: 8px;
  background: #2563eb;
  border-radius: 50%;
}

.timeline .year {
  font-weight: 700;
  color: #2563eb;
  margin-right: 8px;
}

.about-header {
  position: relative;
  text-align: center;
  margin-bottom: 38px;
  margin-top: 8px;
}

.title-watermark {
  position: absolute;
  left: 50%;
  top: -18px;
  transform: translateX(-50%);
  font-size: 2.8rem;
  font-weight: 900;
  color: #1a2a47;
  opacity: 0.09;
  letter-spacing: 0.18em;
  user-select: none;
  pointer-events: none;
  z-index: 1;
  white-space: nowrap;
}

.page-title {
  position: relative;
  z-index: 2;
  text-align: center;
  font-size: 2.1rem;
  font-weight: 700;
  color: #1a2a47;
  margin-bottom: 12px;
  letter-spacing: 1px;
  margin-top: 0;
}

.desc {
  position: relative;
  z-index: 2;
  color: #555;
  font-size: 1.08rem;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}

@media (max-width: 900px) {
  .title-watermark {
    font-size: 1.3rem;
    top: -8px;
  }

  .page-title {
    font-size: 1.1rem;
  }

  .desc {
    font-size: 0.98rem;
  }
}

@media (max-width: 768px) {
  .about-view {
    padding: 8px;
  }

  .about-section,
  .culture-section {
    padding: 16px 6px 16px 6px;
    border-radius: 10px;
  }

  .about-section h1,
  .culture-section h2 {
    font-size: 1.1rem;
  }

  .about-content h3 {
    font-size: 1rem;
  }

  .about-content p,
  .timeline li {
    font-size: 0.98rem;
  }
}
</style>